if (!customElements.get('faq-tabber')) {
  class FaqTabber extends HTMLElement {
    connectedCallback() {
      this.tablist = this.querySelector('.faq-tabs');
      this.tabs = Array.from(this.querySelectorAll('.faq-tab'));
      this.panels = Array.from(this.querySelectorAll('.faq-panel'));
      this.items = Array.from(this.querySelectorAll('.faq-item'));
      this.allowMultiple = this.dataset.allowMultiple === 'true';

      this.bindTabs();
      this.bindAccordions();

      if (this.items.length && this.dataset.openFirst === 'true') {
        this.setOpen(this.items[0], true);
      }
    }

    disconnectedCallback() {
      if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
      clearTimeout(this.resizeTimeout);
    }

    /* Tabs */

    bindTabs() {
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        tab.setAttribute('tabindex', index === 0 ? '0' : '-1');

        tab.addEventListener('click', () => this.selectTab(index));

        tab.addEventListener('keydown', (event) => {
          let next = null;

          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;

          if (next === null) return;

          event.preventDefault();
          this.selectTab(next);
          this.tabs[next].focus();
        });
      });

      this.panels.forEach((panel, index) => {
        panel.dataset.active = index === 0 ? 'true' : 'false';
      });
    }

    selectTab(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      this.panels.forEach((panel, i) => {
        panel.dataset.active = i === index ? 'true' : 'false';
      });

      /* Keep the chosen label visible when the row scrolls sideways */
      if (this.tablist && this.tablist.scrollWidth > this.tablist.clientWidth + 1) {
        this.tabs[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      /* Panels that were mid-measurement need their heights recomputed while hidden */
      this.recomputeHeights();
    }

    /* Accordion */

    bindAccordions() {
      this.items.forEach((item) => {
        const trigger = item.querySelector('.faq-item__trigger');
        const panel = item.querySelector('.faq-item__panel');

        if (!trigger || !panel) return;

        trigger.addEventListener('click', () => {
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';

          if (isOpen) {
            this.setOpen(item, false);
          } else {
            if (!this.allowMultiple) {
              this.items.forEach((other) => {
                if (other !== item) this.setOpen(other, false);
              });
            }
            this.setOpen(item, true);
          }
        });
      });

      this.resizeHandler = () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => this.recomputeHeights(), 150);
      };
      window.addEventListener('resize', this.resizeHandler);
    }

    setOpen(item, open) {
      const trigger = item.querySelector('.faq-item__trigger');
      const panel = item.querySelector('.faq-item__panel');

      if (!trigger || !panel) return;

      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.dataset.open = open ? 'true' : 'false';

      if (open) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        /* Freeze the current height first so there is something to animate from */
        panel.style.maxHeight = panel.scrollHeight + 'px';
        void panel.offsetHeight;
        panel.style.maxHeight = '0px';
      }
    }

    /* Keep open panels exactly as tall as their content after a resize or font load */

    recomputeHeights() {
      const panels = [];

      this.items.forEach((item) => {
        const trigger = item.querySelector('.faq-item__trigger');
        const panel = item.querySelector('.faq-item__panel');

        if (!trigger || !panel) return;
        if (trigger.getAttribute('aria-expanded') !== 'true') return;

        panels.push(panel);
      });

      panels.forEach((panel) => {
        panel.style.maxHeight = 'none';
      });

      const heights = panels.map((panel) => panel.scrollHeight);

      panels.forEach((panel, index) => {
        panel.style.maxHeight = heights[index] + 'px';
      });
    }
  }

  customElements.define('faq-tabber', FaqTabber);
}